<script>
export default {
  name: 'IkhtisarTable',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    // Format Tanggal standar
    formatDate(date) {
      if (!date) return '-'
      try {
        const d = new Date(date)
        if (isNaN(d.getTime())) return '-'
        return d.toLocaleDateString('id-ID', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      } catch (e) {
        return '-'
      }
    },

    // Mengekstrak nominal secara aman di Vue 2
    getNominalTabel(item) {
      if (
        item.details_sum_nominal !== undefined &&
        item.details_sum_nominal !== null
      ) {
        return item.details_sum_nominal
      }
      return item.total_nominal || item.total || 0
    },

    // Format Rupiah untuk total nominal summary
    formatRupiah(value) {
      if (!value) return '0'
      return Number(value)
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    // Class badge status dokumen
    statusBadgeClass(status) {
      const currentStatus = status || 'DRAFT'
      return {
        'badge badge-warning': currentStatus === 'DRAFT',
        'badge badge-success': currentStatus === 'APPROVED',
        'badge badge-secondary':
          currentStatus !== 'DRAFT' && currentStatus !== 'APPROVED',
      }
    },

    // Emit aksi klik lihat/edit detail ke induk
    onActionClick(id) {
      this.$emit('action-click', id)
    },

    // METODE BARU: Emit aksi klik download ke induk
    onDownloadClick(id) {
      this.$emit('download-click', id)
    },

    // Emit aksi klik approve ke induk
    onApproveClick(id) {
      this.$emit('approve-click', id)
    },
  },
}
</script>

<template>
  <div class="table-responsive">
    <table class="table table-sm table-hover mb-0">
      <thead>
        <tr class="header-lvl-1">
          <th class="align-middle text-center" style="width: 5%">No</th>
          <th class="align-middle text-left">No. Ikhtisar / Dokumen</th>
          <th class="align-middle text-center" style="width: 15%"
            >Tanggal Tutup</th
          >
          <th class="align-middle text-right" style="width: 20%"
            >Total Nominal</th
          >
          <th class="align-middle text-center" style="width: 15%">Status</th>
          <th class="align-middle text-center" style="width: 25%">Aksi</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="items.length === 0">
          <td colspan="6" class="text-center py-4 text-muted">
            Belum ada data ikhtisar panjar untuk proyek ini.
          </td>
        </tr>

        <tr v-for="(item, index) in items" :key="item.id">
          <td class="text-center align-middle">{{ index + 1 }}</td>
          <td class="align-middle font-weight-bold text-primary">
            {{ item.no_ikhtisar || 'IKHTISAR-DOC-' + item.id }}
          </td>
          <td class="text-center align-middle">
            {{ formatDate(item.tgl_tutup_panjar) }}
          </td>
          <td class="text-right align-middle font-weight-bold">
            Rp {{ formatRupiah(getNominalTabel(item)) }}
          </td>
          <td class="text-center align-middle">
            <span :class="statusBadgeClass(item.status)">
              {{ item.status || 'DRAFT' }}
            </span>
          </td>
          <td class="text-center align-middle">
            <div
              class="d-flex justify-content-center align-items-center style-gap"
            >
              <button
                class="btn btn-sm font-weight-bold"
                :class="
                  item.status === 'APPROVED'
                    ? 'btn-outline-info'
                    : 'btn-outline-warning'
                "
                @click="onActionClick(item.id)"
              >
                <i
                  :class="
                    item.status === 'APPROVED'
                      ? 'uil uil-search mr-1'
                      : 'uil uil-edit mr-1'
                  "
                ></i>
                {{ item.status === 'APPROVED' ? 'Lihat' : 'Edit' }}
              </button>

              <button
                class="btn btn-sm btn-outline-primary font-weight-bold"
                title="Download Export Excel"
                @click="onDownloadClick(item.id)"
              >
                <i class="uil uil-file-download-alt mr-1"></i>
                Excel
              </button>

              <button
                v-if="item.status !== 'APPROVED'"
                class="btn btn-sm btn-outline-success font-weight-bold"
                @click="onApproveClick(item.id)"
              >
                <i class="uil uil-check-circle mr-1"></i>
                Approve
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.table-responsive {
  overflow: auto;
  max-height: 600px;
  position: relative;
}

.table {
  border-collapse: collapse;
  width: 100%;
  font-size: 13px;
}

.table th,
.table td {
  border: 1px solid #eeeeee;
  padding: 8px 10px;
  background-color: #ffffff;
  white-space: nowrap;
}

/* Header Sticky */
.header-lvl-1 th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa !important;
  z-index: 20;
  border-bottom: 1px solid #dee2e6;
}

/* Efek Hover baris yang halus */
tr:hover td {
  background-color: #f8fafd !important;
}

/* Jarak antar tombol aksi */
.style-gap {
  gap: 6px;
}
</style>
